import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value)return null;
    if(!args)return value;

    return value.filter(function(item){
      const text = args.toLowerCase();
      return item.name ? item.name.toLowerCase().includes(text) : item.toLowerCase().includes(text);
    });
  }

}
